import api from '../api'

export default {

  productGroups: async (page, take, sortBy, sortOrder, search, filters) => {
    return api.get(`api/product-groups?page=${page}&take=${take}&sort_by=${sortBy}&sort_order=${sortOrder}&search=${search}&filters=${filters}`)
  },


  create: async productGroup => {
    return api.post('api/product-groups', productGroup)
  },

  get: async id => {
    return api.get('api/product-groups/' + id)
  },

  update: async (id,productGroup) => {
    return api.put('api/product-groups/' + id, productGroup)
  },

  delete: async id => {
    return api.delete('api/product-groups/' + id)
  }
}
